import React from 'react';
import styles from './InvoiceStatusBadge.module.css';

interface InvoiceStatusBadgeProps {
  status: string;
}

const STATUS_COLOR_MAP: Record<string, string> = {
  Overdue: 'red',
  'Due Soon': 'orange',
  Pending: 'gray',
  paid: 'green',
};

export const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status }) => {
  const color = STATUS_COLOR_MAP[status] || 'gray';
  return (
    <span className={`${styles.badge} ${styles[color]}`}>
      {status}
    </span>
  );
};
